import { api } from './api';

export const profileService = {
  /**
   * Get current user profile
   */
  async getProfile() {
    const response = await api.get('/profile');
    return response.data.data;
  },

  /**
   * Request email change
   */
  async requestEmailChange(newEmail: string) {
    const response = await api.post('/profile/email/request', { newEmail });
    return response.data.data;
  },

  /**
   * Verify email change with token
   */
  async verifyEmailChange(token: string) {
    const response = await api.post('/profile/email/verify', { token });
    return response.data.data;
  },

  /**
   * Request password change
   */
  async requestPasswordChange(currentPassword: string) {
    const response = await api.post('/profile/password/request', { currentPassword });
    return response.data.data;
  },

  /**
   * Complete password change with token
   */
  async completePasswordChange(token: string, newPassword: string, confirmPassword: string) {
    const response = await api.post('/profile/password/complete', { 
      token, 
      newPassword, 
      confirmPassword 
    });
    return response.data.data;
  },

  /**
   * Resend verification email
   */
  async resendVerification(verificationType: 'email_change' | 'password_change') {
    const response = await api.post('/profile/verification/resend', { verificationType });
    return response.data.data;
  },

  /**
   * Create a Stripe Customer Portal session for managing subscription and billing
   */
  async createBillingPortalSession(stripeCustomerId: string): Promise<{ url: string }> {
    const response = await api.post('/clubs/billing-portal', { stripeCustomerId });
    return response.data.data;
  },

  /**
   * Look up the user's Stripe subscription by email
   */
  async getSubscription(): Promise<{
    hasSubscription: boolean;
    stripeCustomerId?: string;
    stripeSubscriptionId?: string;
    status?: string;
    currentPeriodStart?: number;
    currentPeriodEnd?: number;
    cancelAtPeriodEnd?: boolean;
  }> {
    const response = await api.get('/clubs/billing/subscription');
    return response.data.data;
  },
};
